import { generateLink2 } from "@/api/communal";
import { login, } from '@/api/xibDepositStandard.js'
import { Toast } from 'vant'


// 跳转到微信领取奖品
export function toWeChatClaim() {
  let urlToken = sessionStorage.getItem('xiameBankXibSaveMoneyToken')
  const url = `${process.env.VUE_APP_H5_PREFIX_URL}ydsh-ph-h5-bankv3/XiameBankDepositStandardWxCollecting?urlToken=${urlToken}`
  console.log(url);
  // window.location.href = url
  generateLink2({
    link: encodeURIComponent(url)
  }).then(res => {
    window.location.href = res.data.urlLink
  })
}
// 跳转如e宝首页（行方页面）
export function toRueBaoPage() {
  const url = `${process.env.VUE_APP_XIAMENBANK_PREFIX_URL}v4-std/finance/index.html#/finance/finance-ryb?hasCheckHold=1&xibpopup=true`
  console.log(url);
  window.location.href = url
}
// 跳转其他活动首页（行方页面）
export function toEventHomePage() {
  const url = `${process.env.VUE_APP_XIAMENBANK_PREFIX_URL}v4-std/activity-center/index.html#/activity-center/index`
  console.log(url);
  window.location.href = url
}
// 跳到资产提升功能（行方页面）
export function toImprovePage() {
  // const url = `https://mobile.xib.com.cn/v4-std/transfer/index.html#/transfer/other-in/index?xiblogin=true`
  // 2025.4.29更新
  const url = `https://mobile.xib.com.cn/v4-std/transfer/index.html#/other-in/index?xiblogin=true&xibpopup=true&xibshowtopbar=true`


  console.log(url);
  window.location.href = url
}

// 登录接口 ,参数（vue实例）
export function loginFun(that) {
  return new Promise((resolve, reject) => {
    let { token } = that.$route.query
    console.log(that.$route.query);
    if (!token) {
      return Toast('请携带token参数')
    }
    login({ token: token }).then(async res => {
      if (res.code === 0) {
        sessionStorage.setItem('xiameBankXibSaveMoneyToken', res.data.token)
        resolve()
      } else {
        that.loginErrorMsg = res.message
        Toast.fail(res.message)
        reject(res.mesmessages)
      }
    })
  })

}
// 页面图片预先加载
export const preFetchImg = () => {
  let imgs = [
    require("@/assets/imgs/xiameBankDepositStandard/rule1.png"),
    require("@/assets/imgs/xiameBankDepositStandard/rule2.png"),
    require("@/assets/imgs/xiameBankDepositStandard/rule3.png"),

    require("@/assets/imgs/xiameBankDepositStandard/popup.png"),
    require("@/assets/imgs/xiameBankDepositStandard/popup2.png"),
    require("@/assets/imgs/xiameBankDepositStandard/btn3.png"),
    require("@/assets/imgs/xiameBankDepositStandard/btn4.png"),

  ]
  for (let img of imgs) {
    let image = new Image()
    image.src = img
    image.onload = () => { }
  }
}

// 首页图片加载
export const preFetchImgHome = () => {
  return new Promise((resolve,) => {
    let imgs = [
      require("@/assets/imgs/xiameBankDepositStandard/bg.jpg"),
      require("@/assets/imgs/xiameBankDepositStandard/btn1.png"),
      require("@/assets/imgs/xiameBankDepositStandard/recommend1-1.png"),
      require("@/assets/imgs/xiameBankDepositStandard/recommend2-1.png"),
    ]
    let sum = imgs.length
    let num = 0
    for (let img of imgs) {
      let image = new Image()
      image.src = img
      image.onload = () => {
        // 图片加载完整
        num++
        if (sum === num) {
          resolve()
        }
      }
    }
  })
}

// 分享页面打开活动页地址
export function getActivityUrl() {
  let appPage = ''

  switch (process.env.VUE_APP_ENV) {
    case 'development':
      appPage = 'https://xib03.test.xib.com.cn:21443/ifspopenapi/thirdParty/auth/zcts?client_id=xib_ydsh&scope=m&xiblogin=true&xibshowtopbar=false&xibpopup=true'
      break
    case 'production':
      appPage = 'https://ifsp.xib.com.cn/ifspopenapi/thirdParty/auth/zcts2025?client_id=xib_ydsh&scope=m&xiblogin=true&xibshowtopbar=false&xibpopup=true'
      break
    default: // 默认正式环境
      appPage = 'https://ifsp.xib.com.cn/ifspopenapi/thirdParty/auth/zcts2025?client_id=xib_ydsh&scope=m&xiblogin=true&xibshowtopbar=false&xibpopup=true'
  }

  return appPage
}
